module.exports = __webpack_public_path__ + "static/media/coffee_swirls.318f8366.jpg";